/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true, apiVersion: 'v2' });
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(data) {
    return axios.patch(`${this.url}/settings`, data);
  }

  getColumns() {
    return axios.get(`${this.url}/columns`);
  }

  createColumn(data) {
    return axios.post(`${this.url}/columns`, data);
  }

  updateColumn(id, data) {
    return axios.patch(`${this.url}/columns/${id}`, data);
  }

  deleteColumn(id, params = {}) {
    return axios.delete(`${this.url}/columns/${id}`, { params });
  }

  reorderColumns(items) {
    return axios.post(`${this.url}/columns/reorder`, { items });
  }

  getCards(params = {}) {
    return axios.get(`${this.url}/cards`, { params });
  }

  // CSV vem como blob: responseType padrão (json) tentaria parsear a planilha.
  exportCards(params = {}) {
    return axios.get(`${this.url}/cards/export`, {
      params,
      responseType: 'blob',
    });
  }

  moveCard(conversationId, payload) {
    return axios.post(`${this.url}/cards/${conversationId}/move`, payload);
  }

  setStage(conversationId, stageType) {
    return axios.post(`${this.url}/cards/${conversationId}/stage`, {
      stage_type: stageType,
    });
  }
}

export default new KanbanAPI();
